import styled from 'styled-components';
import { Table } from '../../../../../components';

export const TableStyled = styled(Table)`
  margin-top: 3rem;
`;
